import React, { FC } from "react";
import { Button } from "antd";
import { YhBox } from "@/components/YhBox";
import { RouterParamType } from "@/model/navModel";
import { BaseDetail } from "./base";
import { RelevanceTask } from "./task";
import { useOfferDetailModel } from "./offerDetailModel";
import { IOfferTabEnum } from "../../offerTypes";
import { Files } from "./files";
import { MaterialInfo } from "./info";
import { AuditDetail } from "./audit";

export const TabBar: FC<RouterParamType> = (detailsInfo) => {
    const { tabActive, setTabActive } = useOfferDetailModel(({ tabActive }) => [tabActive]);

    //防止保存是表单拿不到， 在下面渲染
    const RenderTabItem = () => {
        switch (tabActive) {
            // case IOfferTabEnum.BASE_DETAIL:
            //     return <BaseDetail {...detailsInfo}/>;
            case IOfferTabEnum.MATERIAL_INFO:
                return <MaterialInfo {...detailsInfo} />;
            case IOfferTabEnum.RELEVANCE_TASK:
                return <RelevanceTask {...detailsInfo} />;
            case IOfferTabEnum.FILES:
                return <Files {...detailsInfo} />;
            case IOfferTabEnum.AUDIT_DETAIL:
                return <AuditDetail {...detailsInfo} />;
            default:
                return <></>
        }
    }

    const classname = (type: IOfferTabEnum) => {
        return 'tab-item ' + (tabActive === type ? 'tab-active' : '')
    }

    const action = <>
        <Button
            className={classname(IOfferTabEnum.BASE_DETAIL)}
            type="link"
            shape="round"
            onClick={() => setTabActive(IOfferTabEnum.BASE_DETAIL)}
        >基本信息</Button>
        <Button
            className={classname(IOfferTabEnum.MATERIAL_INFO)}
            type="link"
            shape="round"
            onClick={() => setTabActive(IOfferTabEnum.MATERIAL_INFO)}
        >商品信息</Button>
        <Button
            className={classname(IOfferTabEnum.RELEVANCE_TASK)}
            type="link"
            shape="round"
            onClick={() => setTabActive(IOfferTabEnum.RELEVANCE_TASK)}
        >关联单据</Button>
        <Button
            className={classname(IOfferTabEnum.FILES)}
            type="link"
            shape="round"
            onClick={() => setTabActive(IOfferTabEnum.FILES)}
        >附件管理</Button>
        <Button
            className={classname(IOfferTabEnum.AUDIT_DETAIL)}
            type="link"
            shape="round"
            onClick={() => setTabActive(IOfferTabEnum.AUDIT_DETAIL)}
        >审批明细</Button>
    </>

    return (
        <>
            <YhBox
                style={{ paddingBottom: 0, marginBottom: "10px" }}
                action={action}
            />
            <div hidden={tabActive !== IOfferTabEnum.BASE_DETAIL}><BaseDetail {...detailsInfo} /></div>
            <RenderTabItem />
        </>
    )
}